import Glide from '@glidejs/glide';

if (document.querySelector('.timeline')) {
  new Glide('.timeline', {
    type: 'slider',
    perView: 3,
    gap: 0,
    bound: true,
    breakpoints: {
      1024: {
        perView: 2
      },
      480: {
        perView: 1
      }
    }
  }).mount();
}

